module.exports = __webpack_public_path__ + "static/media/entregarinju4.c9e4c9d8.jpg";